module.exports = __webpack_public_path__ + "static/media/edit-red.1a51c017.svg";